import InterfaceAsesmenGigi from "@/apiInterface/InterfaceAsesmenGigi";
import ErrorAlert from "@/utility/ErrorAlert";

class DataAsesmenGigi {

  async getDataAsesmenGigiByReg(reg) {
    let dt: any;
    await InterfaceAsesmenGigi.getAsesmenGigiByReg(reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Asesmen Gigi dan Rongga Mulut by Register");
      });

    return dt;
  }

  async saveDataAsesmenGigi(tgl_periksa, reg, rm, data_medis, odontogram_lain, dokter_id, user_id) {
    let dt: object = {};
    await InterfaceAsesmenGigi.saveAsesmenGigi(tgl_periksa, reg, rm, data_medis, odontogram_lain, dokter_id, user_id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });

    return dt;
  }
  async editDataAsesmenGigi(id, tgl_periksa, reg, rm, data_medis, odontogram_lain, dokter_id, user_id) {
    let dt: object = {};
    await InterfaceAsesmenGigi.editAsesmenGigi(id, tgl_periksa, reg, rm, data_medis, odontogram_lain, dokter_id, user_id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });

    return dt;
  }
}

export default new DataAsesmenGigi();
